<template>
  <div>
    <h3 class="section-title">Explore OHI</h3>
    <div class="announcement-item">
      <img src="/img/music-license-image.png" alt="ExploreOHI" />
      <div class="announcement">
        <h4 class="title">Open Enrollment for 2024 Music Licensing is happening now!</h4>
        <p>
          Invoices must be paid by December 20, 2023 to ensure your discounted licenses for the 2024 calendar year. Failure to do so will result in the loss of the OHI discount for the calendar year.
        </p>
        <a :href='WP_URL+"/membership/member-benefits/music-licensing/"'
          class="button-rg-green">
          Learn More
        </a>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      WP_URL: process.env.VUE_APP_WP_WEBSITE_URL,
    };
  },
};
</script>
<style lang="scss" scoped>
.section-title {
  margin: 0;
  margin-top: 50px;
  text-transform: unset;
  font-weight: normal;
  padding: 32px 0;
  color: #403f3c;
  border-top: 4px solid rgba(217, 217, 217, 0.5);
}
.announcement-item {
  display: grid;
  grid-template-columns: 65% 1fr;
  grid-column-gap: 50px;
  img {
    width: 100%;
  }
  .announcement {
    align-self: center;
    .title {
      font-weight: bold;
      color: #3594bd;
      margin-bottom: 10px;
    }
  }
  @media (max-width: 992px) {
    grid-template-columns: repeat(1, 1fr);
    grid-row-gap: 20px;
  }
}
</style>
